import React, { Component } from 'react';
import { connect } from 'react-redux';
import './modalProgress.css';
import { getStats } from '../reducers/mainReducer';

export class ModalProgress extends Component {

    render() {
        if (!this.props.open) return null;

        const stats = this.props.statsKey == null ? this.props.stats : (this.props.stats ? this.props.stats[this.props.statsKey] : null);
        const done = stats != null;
        const withWarnings = this.props.warningMsg?.length > 0;
        const title = done && this.props.doneTitle ? this.props.doneTitle : this.props.title;

        const cardClass = done && withWarnings ? 'progress-card warning' : 'progress-card';

        return (
            <div className="progress-overlay">
                <div className={cardClass}>
                    {done ? <div className="checkmark-circle" /> : <div className="spinner" />}
                    <div className="progress-title">{title}</div>
                    <div className="progress-label">
                        {this.props.label ? this.props.label : "Missing label."}
                    </div>
                    {done && withWarnings &&
                        <div id="warningMsg">{this.props.warningMsg}</div>
                    }
                    {done &&
                        <button className="progress-done-btn" onClick={this.props.onClose}>
                            Done
                        </button>
                    }
                </div>
            </div>
        );
    }
}

/* istanbul ignore next */
export default connect(function (store){
    return {
      stats: getStats(store)
    };
})(ModalProgress);
